import React, { useState } from 'react';
import { api } from '../api/client';

const LeaderboardsPage: React.FC = () => {
  const [season, setSeason] = useState('S1');
  const [rankings, setRankings] = useState<any[]>([]);
  const [loadedSeason, setLoadedSeason] = useState<string>('');

  const load = async () => {
    const res = await api.get<{ season: string; rankings: any[] }>(`/leaderboards/${season}`);
    setRankings(res.rankings);
    setLoadedSeason(res.season);
  };

  return (
    <div className="space-y-6">
      <div className="p-5 rounded-xl bg-gray-900/70 border border-gray-800">
        <h2 className="text-xl font-semibold flex items-center gap-2"><i className="fas fa-trophy text-yellow-400"></i> <span>Leaderboards</span></h2>
        <div className="flex gap-2 mt-3">
          <input className="px-3 py-2 rounded bg-gray-800 text-white" value={season} onChange={(e) => setSeason(e.target.value)} />
          <button className="px-4 py-2 rounded bg-gray-700 hover:bg-gray-600" onClick={load}>Load</button>
        </div>
        {loadedSeason && (
          <div className="mt-3">
            <div className="text-sm text-gray-400">Season: {loadedSeason}</div>
            <div className="mt-2 space-y-2">
              {rankings.map((r, idx) => (
                <div key={idx} className={`flex justify-between p-3 rounded bg-gray-800 ${idx < 3 ? 'border border-yellow-600/40' : ''}`}>
                  <span className="flex items-center gap-2">{idx < 3 && <i className="fas fa-medal text-yellow-400"></i>} <span>#{idx + 1}</span></span>
                  <span>{r.userId}</span>
                  <span className="font-semibold">{r.score}</span>
                </div>
              ))}
              {rankings.length === 0 && <div className="text-sm text-gray-400">No rankings yet.</div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaderboardsPage;